import * as GoogleUser from '../../../../../../util/GoogleUserExportTypes'
import { StaffConfiguration, StudentConfiguration } from '../../../../../../util/GoogleUserExportTypes';


const bitCount = (i: number) => {
    i = i - ((i >> 1) & 0x55555555);
    i = (i & 0x33333333) + ((i >> 2) & 0x33333333);
    i = (i + (i >> 4)) & 0x0F0F0F0F;
    return (i * 0x01010101) >> 24;
}

export const validateStudentConfig = (studentConfig: StudentConfiguration, validation: string[]) => {
    //lifecyclemanagement is always configurable
    if (studentConfig.archiveGracePeriod < 0) {
        validation.push('studentConfiguration.archiveGracePeriod');
    }

    if (studentConfig.deleteAfterDays === undefined || (studentConfig.deleteAfterDays !== null && studentConfig.deleteAfterDays < 0)) {
        validation.push('studentConfiguration.deleteAfterDays');
    }

    if (!studentConfig.enabled) {
        return;
    }

    if (studentConfig.displayNamePolicy.suffix === GoogleUser.DisplayNameSuffixType.NONE) {
        validation.push('studentConfiguration.displayNamePolicy.suffix');
    }

    if (studentConfig.emailAddressPolicy.type === GoogleUser.EmailAddressPolicyType.GENERATED) {
        let totalCharacterCount = 0;
        if (studentConfig.emailAddressPolicy.includeGivenName) {
            if (studentConfig.emailAddressPolicy.givenNameCharacterCount !== null) {
                if (Number.isNaN(studentConfig.emailAddressPolicy.givenNameCharacterCount)
                    || studentConfig.emailAddressPolicy.givenNameCharacterCount < 1) {
                    validation.push('studentConfiguration.emailAddressPolicy.givenNameCharacterCount');
                }
                else {
                    totalCharacterCount += studentConfig.emailAddressPolicy.givenNameCharacterCount;
                }
            }
            else {
                totalCharacterCount += 100;
            }
        }

        if (studentConfig.emailAddressPolicy.includeFamilyName) {
            if (studentConfig.emailAddressPolicy.familyNameCharacterCount !== null) {
                if (Number.isNaN(studentConfig.emailAddressPolicy.familyNameCharacterCount)
                    || studentConfig.emailAddressPolicy.familyNameCharacterCount < 1) {
                    validation.push('studentConfiguration.emailAddressPolicy.familyNameCharacterCount');
                }
                else {
                    totalCharacterCount += studentConfig.emailAddressPolicy.familyNameCharacterCount;
                }
            }
            else {
                totalCharacterCount += 100;
            }
        }

        if ((!studentConfig.emailAddressPolicy.includeFamilyName && !studentConfig.emailAddressPolicy.includeGivenName) || totalCharacterCount < 4) {
            validation.push('studentConfiguration.emailAddressPolicy.nameCharacterTotalCount');
        }

        if (studentConfig.emailAddressPolicy.serialNumberDelimiter === '') {
            validation.push('studentConfiguration.emailAddressPolicy.serialNumberDelimiter');
        }
    }

    if (studentConfig.emailAddressPolicy.type === GoogleUser.EmailAddressPolicyType.ANONYMOUS) {
        if (studentConfig.emailAddressPolicy.randomCharacterCount < 0) {
            validation.push('studentConfiguration.emailAddressPolicy.randomCharacterCount');
        }
        if (studentConfig.emailAddressPolicy.randomNumberCount < 0) {
            validation.push('studentConfiguration.emailAddressPolicy.randomNumberCount');
        }
        if ((studentConfig.emailAddressPolicy.randomCharacterCount +
            studentConfig.emailAddressPolicy.randomNumberCount) < 6) {
            validation.push('studentConfiguration.emailAddressPolicy.randomTotalCount');
        }
    }

    if (studentConfig.emailAddressPolicy.domainName === '') {
        validation.push('studentConfiguration.emailAddressPolicy.domainName');
    }

    if (studentConfig.passwordPolicy.type === GoogleUser.PasswordPolicyType.RANDOM) {
        if (studentConfig.passwordPolicy.minLength < 8) {
            validation.push('studentConfiguration.passwordPolicy.minLength');
        }

        if ((studentConfig.passwordPolicy.maxLength < studentConfig.passwordPolicy.minLength
            || studentConfig.passwordPolicy.maxLength < 8) || studentConfig.passwordPolicy.maxLength > 100) {
            validation.push('studentConfiguration.passwordPolicy.maxLength');
        }

        if (bitCount(studentConfig.passwordPolicy.passwordCharacterSets) < 2) {
            validation.push('studentConfiguration.passwordPolicy.passwordCharacterSets');
        }
    }

    if (!studentConfig.passwordPolicy.useMonthAndDayFromSocialnumber &&
        studentConfig.passwordPolicy.staticValue.length < 8) {
        validation.push('studentConfiguration.passwordPolicy.staticValue');
    }
    if (studentConfig.passwordPolicy.useMonthAndDayFromSocialnumber &&
        studentConfig.passwordPolicy.staticValue.length < 4) {
        validation.push('studentConfiguration.passwordPolicy.staticValue');
    }
};


export const validateStaffConfig = (staffConfig: StaffConfiguration, validation: string[]) => {
    //lifecyclemanagement is always configurable
    if (staffConfig.archiveGracePeriod < 0) {
        validation.push('staffConfiguration.archiveGracePeriod');
    }

    if (staffConfig.deleteAfterDays === undefined || (staffConfig.deleteAfterDays !== null && staffConfig.deleteAfterDays < 0)) {
        validation.push('staffConfiguration.deleteAfterDays');
    }

    if (!staffConfig.enabled) {
        return;
    }

    //DisplayName
    if (staffConfig.displayNamePolicy.suffix === GoogleUser.DisplayNameSuffixType.NONE) {
        validation.push('staffConfiguration.displayNamePolicy.suffix');
    }

    //EmailPolicy
    if (staffConfig.emailAddressPolicy.type === GoogleUser.EmailAddressPolicyType.GENERATED) {
        let totalCharacterCount = 0;
        if (staffConfig.emailAddressPolicy.includeGivenName) {
            if (staffConfig.emailAddressPolicy.givenNameCharacterCount !== null) {
                if (Number.isNaN(staffConfig.emailAddressPolicy.givenNameCharacterCount)
                    || staffConfig.emailAddressPolicy.givenNameCharacterCount < 1) {
                    validation.push('staffConfiguration.emailAddressPolicy.givenNameCharacterCount');
                }
                else {
                    totalCharacterCount += staffConfig.emailAddressPolicy.givenNameCharacterCount;
                }
            }
            else {
                totalCharacterCount += 100;
            }
        }

        if (staffConfig.emailAddressPolicy.includeFamilyName) {
            if (staffConfig.emailAddressPolicy.familyNameCharacterCount !== null) {
                if (Number.isNaN(staffConfig.emailAddressPolicy.familyNameCharacterCount)
                    || staffConfig.emailAddressPolicy.familyNameCharacterCount < 1) {
                    validation.push('staffConfiguration.emailAddressPolicy.familyNameCharacterCount');
                }
                else {
                    totalCharacterCount += staffConfig.emailAddressPolicy.familyNameCharacterCount;
                }
            }
            else {
                totalCharacterCount += 100;
            }
        }

        if ((!staffConfig.emailAddressPolicy.includeFamilyName && !staffConfig.emailAddressPolicy.includeGivenName) || totalCharacterCount < 4) {
            validation.push('staffConfiguration.emailAddressPolicy.nameCharacterTotalCount');
        }

        if (staffConfig.emailAddressPolicy.serialNumberDelimiter === '') {
            validation.push('staffConfiguration.emailAddressPolicy.serialNumberDelimiter');
        }
    }

    if (staffConfig.emailAddressPolicy.type === GoogleUser.EmailAddressPolicyType.ANONYMOUS) {
        if (staffConfig.emailAddressPolicy.randomCharacterCount < 0) {
            validation.push('staffConfiguration.emailAddressPolicy.randomCharacterCount');
        }
        if (staffConfig.emailAddressPolicy.randomNumberCount < 0) {
            validation.push('staffConfiguration.emailAddressPolicy.randomNumberCount');
        }
        if ((staffConfig.emailAddressPolicy.randomCharacterCount +
            staffConfig.emailAddressPolicy.randomNumberCount) < 6) {
            validation.push('staffConfiguration.emailAddressPolicy.randomTotalCount');
        }
    }

    if (staffConfig.emailAddressPolicy.domainName === '') {
        validation.push('staffConfiguration.emailAddressPolicy.domainName');
    }

    //Password
    if (staffConfig.passwordPolicy.type === GoogleUser.PasswordPolicyType.RANDOM) {
        if (staffConfig.passwordPolicy.minLength < 8) {
            validation.push('staffConfiguration.passwordPolicy.minLength');
        }

        if ((staffConfig.passwordPolicy.maxLength < staffConfig.passwordPolicy.minLength
            || staffConfig.passwordPolicy.maxLength < 8) || staffConfig.passwordPolicy.maxLength > 100) {
            validation.push('staffConfiguration.passwordPolicy.maxLength');
        }

        if (bitCount(staffConfig.passwordPolicy.passwordCharacterSets) < 2) {
            validation.push('staffConfiguration.passwordPolicy.passwordCharacterSets');
        }
    }

    if (!staffConfig.passwordPolicy.useMonthAndDayFromSocialnumber &&
        staffConfig.passwordPolicy.staticValue.length < 8) {
        validation.push('staffConfiguration.passwordPolicy.staticValue');
    }
    if (staffConfig.passwordPolicy.useMonthAndDayFromSocialnumber &&
        staffConfig.passwordPolicy.staticValue.length < 4) {
        validation.push('staffConfiguration.passwordPolicy.staticValue');
    }
};
